"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deregisterCurrency = void 0;
const web3_js_1 = require("@solana/web3.js");
const state_1 = require("../state");
/**
 * Deregisters a Currency Mint
 * @param program - GalacticMarketplace Program
 * @param updateAuthorityAccount - Update Authority
 * @param currencyMint - Currency Mint to be disabled
 * @returns InstructionReturn
 */
function deregisterCurrency(program, updateAuthorityAccount, currencyMint) {
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods
                .deregisterCurrency()
                .accountsStrict({
                updateAuthorityAccount: updateAuthorityAccount.publicKey(),
                marketVarsAccount: state_1.MarketVars.findAddress(program)[0],
                registeredCurrency: state_1.RegisteredCurrency.findAddress(program, currencyMint)[0],
                currencyMint,
                systemProgram: web3_js_1.SystemProgram.programId,
            })
                .instruction(),
            signers: [updateAuthorityAccount],
        });
    });
}
exports.deregisterCurrency = deregisterCurrency;
//# sourceMappingURL=deregisterCurrency.js.map